"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _userflow = require("../../utils/userflow");
var _Button = _interopRequireDefault(require("../Button"));
var _HotelRoomOffers = _interopRequireDefault(require("../HotelRoomOffers"));
var _HotelRoomOffersMobile = _interopRequireDefault(require("../HotelRoomOffersMobile"));
var _userflow2 = require("../../constants/userflow");
var _utils = require("./utils");
var _excluded = ["items", "nights", "searchedNights", "onOfferClicked", "hotelFacilities", "isMobile", "isWhiteLabel", "visibleColumns", "isRoulette", "activateCashbackForPartner", "isSetDefaultFilters", "onClickGallery", "children", "onClickOpenFilters", "onLeaveNotFullOffersSpan", "labelColor", "textColor", "className", "cashbackLabel", "hasCashbackLabel", "cashbackIconWebp", "cashbackIconPng", "cashbackTooltipText", "onClickShowMoreRooms"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// How many items is rendered per tick to avoid freezes.
var BATCH_SIZE = 3;
var VARIANTS_PLURALIZE = [_localization.i18n.t('hotel.room.variants', {
  count: 0
}), _localization.i18n.t('hotel.room.variants', {
  count: 1
}), _localization.i18n.t('hotel.room.variants', {
  count: 2
})];
var HotelSearchResults = function HotelSearchResults(_ref) {
  var items = _ref.items,
    nights = _ref.nights,
    searchedNights = _ref.searchedNights,
    onOfferClicked = _ref.onOfferClicked,
    hotelFacilities = _ref.hotelFacilities,
    isMobile = _ref.isMobile,
    isWhiteLabel = _ref.isWhiteLabel,
    visibleColumns = _ref.visibleColumns,
    isRoulette = _ref.isRoulette,
    activateCashbackForPartner = _ref.activateCashbackForPartner,
    isSetDefaultFilters = _ref.isSetDefaultFilters,
    onClickGallery = _ref.onClickGallery,
    children = _ref.children,
    onClickOpenFilters = _ref.onClickOpenFilters,
    onLeaveNotFullOffersSpan = _ref.onLeaveNotFullOffersSpan,
    labelColor = _ref.labelColor,
    textColor = _ref.textColor,
    className = _ref.className,
    cashbackLabel = _ref.cashbackLabel,
    hasCashbackLabel = _ref.hasCashbackLabel,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng,
    cashbackTooltipText = _ref.cashbackTooltipText,
    onClickShowMoreRooms = _ref.onClickShowMoreRooms,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var offersCount = (0, _size2["default"])(items);
  var _useState = (0, _react.useState)(BATCH_SIZE),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visibleItemsCount = _useState2[0],
    setVsibleItemsCount = _useState2[1];
  // show all items on mobile by default.
  var hiddenOffersCount = offersCount - visibleItemsCount;
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isClamped = _useState4[0],
    setClamped = _useState4[1];
  var itemsToShow = items.slice(0, visibleItemsCount);
  (0, _react.useEffect)(function () {
    if (!isClamped && visibleItemsCount < offersCount) {
      // render next batch in next tick to prevent ui freeze
      setTimeout(function () {
        return setVsibleItemsCount(visibleItemsCount + BATCH_SIZE);
      }, 0);
    }
  }, [visibleItemsCount, isClamped]);
  var StyledOffersItem = isMobile ? StyledMobileItem : StyledDesktopItem;
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, rest, isSetDefaultFilters ? /*#__PURE__*/_react["default"].createElement(StyledNotFullOffers, {
    isMobile: isMobile
  }, t('hotel.ratesResults.notFullOffersАccommodation_package'), isMobile ? /*#__PURE__*/_react["default"].createElement("br", null) : ' ', t('hotel.ratesResults.notFullOffersFilters'), /*#__PURE__*/_react["default"].createElement(StyledSpan, {
    onClick: onClickOpenFilters,
    onMouseLeave: onLeaveNotFullOffersSpan,
    isMobile: isMobile
  }, t('hotel.ratesResults.notFullOffersButton'))) : null, itemsToShow.map(function (item, index) {
    var mealTypes = (0, _utils.sortAndFilterMealTypes)(item.meal_types, item, searchedNights);
    if (!item.offers) return null;
    return /*#__PURE__*/_react["default"].createElement(StyledItemWrapper, {
      key: item.ID
    }, /*#__PURE__*/_react["default"].createElement(StyledOffersItem, {
      index: index,
      room: item.room,
      mealTypes: mealTypes,
      offers: item.offers,
      labels: item.labels,
      nights: nights,
      hotelFacilities: hotelFacilities,
      selectedNights: searchedNights,
      onOfferClicked: onOfferClicked,
      visibleColumns: visibleColumns,
      isRoulette: isRoulette,
      bonusCount: activateCashbackForPartner ? item.bonus_count : null,
      isHotelOnly: false,
      isWhiteLabel: isWhiteLabel,
      onClickGallery: onClickGallery,
      isMobile: isMobile,
      labelColor: labelColor,
      textColor: textColor,
      className: className,
      cashbackLabel: cashbackLabel,
      hasCashbackLabel: hasCashbackLabel,
      cashbackIconWebp: cashbackIconWebp,
      cashbackIconPng: cashbackIconPng,
      cashbackTooltipText: cashbackTooltipText
    }));
  }), isClamped && hiddenOffersCount > 0 && /*#__PURE__*/_react["default"].createElement(ShowMoreButton, {
    $isMobile: isMobile,
    functional: true,
    onClick: function onClick() {
      setClamped(false);
      onClickShowMoreRooms === null || onClickShowMoreRooms === void 0 || onClickShowMoreRooms();
    }
  }, t('hotel.room.showMore', {
    pluralize: "".concat(hiddenOffersCount, " ").concat((0, _userflow.pluralize)(hiddenOffersCount, VARIANTS_PLURALIZE))
  })), children);
};
var StyledDesktopItem = (0, _styledComponents["default"])(_HotelRoomOffers["default"]).withConfig({
  displayName: "HotelSearchResults__StyledDesktopItem",
  componentId: "sc-e9z9x3-0"
})(["animation-delay:", "ms;"], function (_ref2) {
  var index = _ref2.index;
  return index * _userflow2.SKELETON_ANIMATION_DELAY;
});
var StyledMobileItem = (0, _styledComponents["default"])(_HotelRoomOffersMobile["default"]).withConfig({
  displayName: "HotelSearchResults__StyledMobileItem",
  componentId: "sc-e9z9x3-1"
})(["width:100%;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelSearchResults__StyledContainer",
  componentId: "sc-e9z9x3-2"
})(["display:flex;flex-direction:column;align-items:center;"]);
var StyledItemWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelSearchResults__StyledItemWrapper",
  componentId: "sc-e9z9x3-3"
})(["margin-bottom:10px;display:flex;width:100%;border-radius:var(--border-radius);", "{border-radius:var(--border-radius);}"], StyledDesktopItem);
var ShowMoreButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelSearchResults__ShowMoreButton",
  componentId: "sc-e9z9x3-4"
})(["display:flex;align-self:flex-start;padding:12px 16px;--background-color:var(--white);background-color:var(--background-color);border-radius:var(--border-radius);color:var(--black);font-size:14px;font-style:normal;font-weight:400;:hover{background:linear-gradient( 0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100% ),var(--background-color);}:active{background:linear-gradient( 0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100% ),var(--background-color);}", ";"], function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["margin:auto;"]);
});
var StyledNotFullOffers = _styledComponents["default"].div.withConfig({
  displayName: "HotelSearchResults__StyledNotFullOffers",
  componentId: "sc-e9z9x3-5"
})(["width:100%;height:", "px;background:var(--background);border-radius:var(--border-radius);color:var(--black);margin-bottom:4px;", ""], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? '72' : '40';
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? "\n    padding: 12px;\n    text-align: center;\n    font-size: 14px;\n  " : "font-size: 14px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    ";
});
var StyledSpan = _styledComponents["default"].span.withConfig({
  displayName: "HotelSearchResults__StyledSpan",
  componentId: "sc-e9z9x3-6"
})(["color:var(--secondary);cursor:pointer;border:0;", ""], function (_ref6) {
  var isMobile = _ref6.isMobile;
  return !isMobile && 'margin-left: 3px;';
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelSearchResults);